'use client';
import ProductsPage from '@c/ProductsPage';
import type { BrandDocument } from '@models/brand';
import type { CategoryDocument } from '@models/category';
import type { PageSideFilters, TopFilters } from '@util/hooks/useProductsPage';
import type { Pagination } from '@util/types/paginator';
import type { FacetCounts, ProductLight } from 'models/product';

export interface BrandDetailPageProps {
  brand: BrandDocument;
  initialProducts: ProductLight[];
  initialPageInfo: Pagination;
  initialTopFilters: TopFilters;
  initialSideFilters: PageSideFilters;
  categories: CategoryDocument[];
  facet_counts?: FacetCounts;
  // sellers: {
  //   [key: string]: PublicUserDocument;
  // };
}

const BrandDetailPage = ({
  brand,
  facet_counts,
  initialProducts,
  initialPageInfo,
  initialTopFilters,
  initialSideFilters,
}: // sellers,
BrandDetailPageProps) => {
  return (
    <ProductsPage
      facet_counts={facet_counts}
      initialProducts={initialProducts}
      initialPageInfo={initialPageInfo}
      initialTopFilters={initialTopFilters}
      initialSideFilters={initialSideFilters}
      headerBreadcrumb={{ label: brand.name, href: brand.url }}
      pageHeaderTitle={brand.name}
      pageHeaderBody={brand.description}
      brand={brand}
      pageType="brand"
      keyword={null}
      seller_id={null}
      categories={[]}
      // sellers={sellers}
    />
  );
};

export default BrandDetailPage;
